/**
 * Store Pinia — theme
 *
 * Migré depuis `store/modules/theme.js`. Apparence de l'app (drawer, couleurs, image
 * de fond, mode sombre). Persisté en localStorage.
 *
 * Équivalences mutations Vuex → actions Pinia :
 *   SET_BAR_IMAGE        → setBarImage
 *   SET_DRAWER           → setDrawer
 *   SET_SCRIM            → setScrim
 *   SET_DARK_MODE        → setDarkMode
 *   SET_THEME_COLOR      → setThemeColor
 *   SET_BAR_IMAGE_TOGGLE → setBarImageToggle
 */
import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
  state: () => ({
    barColor: 'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
    barImage: 'login.jpg',
    barImageToggle: false,
    drawer: null,
    darkMode: false,
    color: '#E91E63', // Couleur du thème (Primary)
  }),

  actions: {
    setBarImage (payload) {
      this.barImage = payload
    },
    setDrawer (payload) {
      this.drawer = payload
    },
    setScrim (payload) {
      this.barColor = payload
    },
    setDarkMode (payload) {
      this.darkMode = payload
    },
    setThemeColor (payload) {
      this.color = payload
    },
    setBarImageToggle (payload) {
      this.barImageToggle = payload
    },
  },

  persist: true,
})
